module.exports = __webpack_public_path__ + "img/engagementring.2ae4423.webp";